import React from "react";
import { NavLink, Outlet, Navigate, useNavigate, Link } from "react-router-dom";
import { Package, ShoppingBag, Settings, LogOut, LayoutDashboard } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

import { LOGO_IMAGE as LOGO_URL } from "../../lib/siteImages";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Commandes", icon: ShoppingBag },
  { to: "/admin/products", label: "Produits", icon: Package },
  { to: "/admin/settings", label: "Paramètres", icon: Settings },
];

const AdminLayout = () => {
  const { admin, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!admin) return <Navigate to="/admin/login" replace />;

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="bg-night-2 border-r border-subtle md:min-h-screen flex flex-col">
        <Link to="/admin" className="flex items-center gap-3 p-5 border-b border-subtle">
          <img src={LOGO_URL} alt="Noctua" width="36" height="36" className="h-9" data-testid="admin-layout-logo" />
          <div>
            <p className="font-display text-lg text-white leading-none">Noctua</p>
            <p className="eyebrow text-[9px] mt-1">Admin</p>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`admin-nav-${item.to.split("/").pop() || "dashboard"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-[#d4af37] text-[#0a0f1a] font-semibold"
                    : "text-gray-300 hover:bg-white/5"
                }`
              }
            >
              <item.icon size={16} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-subtle">
          <p className="text-xs text-gray-500 px-4 mb-2">{admin.email}</p>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-btn"
            className="flex items-center gap-3 px-4 py-3 text-sm text-gray-400 hover:bg-white/5 w-full transition-colors"
          >
            <LogOut size={16} />
            Déconnexion
          </button>
        </div>
      </aside>

      <main className="p-5 sm:p-10 bg-night">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
